import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import { ServerResponse } from '../types';
import {
  API_PATH_BACKUP_RESTORE,
  API_PATH_BACKUP_TASKS,
  BackupFileDTO,
  BackupRequestDTO,
  BackupJobListResponseDTO
} from './backup.types';

const http = Http.getHttp();

export function deleteBackupFileByFilename(
  filename: string,
  product: string
): AxiosPromise<ServerResponse<BackupFileDTO>> {
  const encodedFilename = encodeURIComponent(filename);
  return http.delete(`${API_PATH_BACKUP_RESTORE}/${encodedFilename}`, {
    params: {
      product
    }
  });
}

export function deleteJob(product: string, jobId: string): AxiosPromise<ServerResponse<void>> {
  return http.delete(`${API_PATH_BACKUP_RESTORE}/jobs/${jobId}`, {
    params: {
      product
    }
  });
}

export function getAllBackupTasks(): AxiosPromise<
  ServerResponse<BackupJobListResponseDTO>
> {
  return http.get(`${API_PATH_BACKUP_RESTORE}${API_PATH_BACKUP_TASKS}`);
}

export function requestBackup(
  body: BackupRequestDTO
): AxiosPromise<ServerResponse<BackupJobListResponseDTO>> {
  return http.post(`${API_PATH_BACKUP_RESTORE}/create`, body);
}

export function restoreBackup(
  body: BackupRequestDTO
): AxiosPromise<ServerResponse<void>> {
  return http.post(`${API_PATH_BACKUP_RESTORE}/restore`, body);
}
